/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { merge } from 'lodash';

const defaults = {};

/* eslint-disable @typescript-eslint/no-explicit-any */
export function filterRequestTransformer(data: any) {
  return merge({}, defaults, data);
}
